import { Link } from "react-router-dom";
import { version } from "../../package.json";

const PageFooter = () => {
  return (
    <footer className="glass-card border-t border-border/30 mt-auto">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
          <Link to="/imprint" className="hover:text-primary transition-colors">
            Imprint
          </Link>
          <span className="text-border">|</span>
          <Link to="/terms" className="hover:text-primary transition-colors">
            Terms
          </Link>
          <span className="text-border">|</span>
          <Link to="/privacy-policy" className="hover:text-primary transition-colors">
            Privacy Policy
          </Link>
          <span className="text-border">|</span>
          <Link to="/contact" className="hover:text-primary transition-colors">
            Contact
          </Link>
          <span className="text-border">|</span>
          <span className="text-muted-foreground/60">v{version}</span>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
